import { useCallback, useContext, useEffect } from 'react'
import { LayoutContext } from 'contexts/LayoutContext'
import { RESET_LAYOUT, SET_HEADER_TRANSPARENCY } from 'constants/layout'

export function useLayout() {
  const { dispatch } = useContext(LayoutContext)

  useEffect(() => () => dispatch && dispatch({ type: RESET_LAYOUT }), [dispatch])

  const updatedHeaderTransparency = useCallback(
    isTransparent =>
      dispatch && dispatch({ type: SET_HEADER_TRANSPARENCY, isHeaderTransparent: isTransparent }),
    [dispatch]
  )

  return {
    updatedHeaderTransparency,
  }
}

export default useLayout
